import React, { useEffect, useState } from "react";
import selenium from "../../assets/Technologies/logo/selenium.png";
import postman from "../../assets/Technologies/logo/postman-logo-big.png";
import jmeter from "../../assets/Technologies/logo/Apache_JMeter.png";
import maven from "../../assets/Technologies/logo/Apache_Maven_logo.svg.png";
import git from "../../assets/Technologies/logo/git.png";
import android from "../../assets/Technologies/logo/android-logo.png";
import aws from "../../assets/Technologies/logo/Amazon_Web_Services.png";
import csshtml from "../../assets/Technologies/logo/CSS-Logo.png";
import python from "../../assets/Technologies/logo/Python-Logo.png";
import sonar from "../../assets/Technologies/logo/sonar.png";
import tailwind from "../../assets/Technologies/logo/tailwind.png";
import sql from "../../assets/Technologies/logo/Mysql_logo.png";
import vite from "../../assets/Technologies/logo/vite.png";
import devops from "../../assets/Technologies/logo/logo-devops.png";
import reactjs from "../../assets/Technologies/logo/react.js-img.png";
import springboot from "../../assets/Technologies/logo/spring boot.png";
import ios from "../../assets/Technologies/logo/iOS-Symbol.png";
import java from "../../assets/Technologies/logo/java-logo.png";
import "@fontsource/manrope";
import "@fontsource/syne";
import { Element } from "react-scroll";
import { motion, useMotionValue, useAnimationFrame } from "framer-motion";
const techs = [
  { src: springboot, width: 80, height: 70 },
  { src: reactjs, width: 65, height: 70 },
  { src: ios, width: 55, height: 70 },
  { src: vite, width: 65, height: 70 },
  { src: sql, width: 80, height: 70 },
  { src: devops, width: 80, height: 70 },
  { src: android, width: 65, height: 70 },
  { src: sonar, width: 80, height: 70 },
  { src: tailwind, width: 70, height: 70 },
  { src: java, width: 65, height: 70 },
  { src: aws, width: 80, height: 70 },
  { src: selenium, width: 70, height: 70 },
  { src: postman, width: 70, height: 70 },
  { src: jmeter, width: 80, height: 70 },
  { src: maven, width: 80, height: 70 },
  { src: python, width: 70, height: 70 },
  // { src: csshtml, width: 80, height: 70 },
  // { src: git, width: 70, height: 70 },
];

function TechLogo({ src, width = 80, height = 80 }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
    >
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          width: "100%",
          aspectRatio: "1",
          maxWidth: 96,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 16,
          border: hovered
            ? "2px solid rgba(86,61,124,0.25)"
            : "2px solid rgba(86,61,124,0.08)",
          background: hovered ? "#fff" : "transparent",
          boxShadow: hovered ? "0 8px 28px rgba(86,61,124,0.12)" : "none",
          transform: hovered ? "translateY(-4px)" : "translateY(0)",
          transition: "all 0.22s ease",
          padding: "0.85rem",
        }}
      >
        <img
          src={src}
          alt=""
          width={width}
          height={height}
          style={{
            objectFit: "contain",
            filter: hovered ? "none" : "grayscale(30%)",
            transition: "filter 0.22s, opacity 0.22s",
          }}
        />
      </div>
    </div>
  );
}

const Projectprogress = () => {
  const duplicatedTechs = [...techs, ...techs];

  const x = useMotionValue(0);
  const [paused, setPaused] = useState(false);

  useAnimationFrame((_, delta) => {
    if (paused) return;

    const speed = 0.05; // px per ms

    let current = x.get();
    current -= delta * speed;

    // Reset when one full set has passed
    if (current <= -2160) {
      current = 0;
    }

    x.set(current);
  });

  return (
    <Element name="Technologies">
      <div className="bg-white py-5">
        <div className="container-fluid" style={{ maxWidth: 1100 }}>
          {/* Heading */}
          <div className="mb-5">
            <p
              style={{
                fontSize: "0.7rem",
                fontWeight: 700,
                letterSpacing: "0.14em",
                textTransform: "uppercase",
                color: "#563D7C",
                marginBottom: "0.5rem",
              }}
            >
              Our Stack
            </p>
            <h2
              style={{
                fontWeight: 800,
                color: "#1a1a2e",
                fontSize: "clamp(1.4rem, 3vw, 2rem)",
                fontFamily: "'Syne', sans-serif",
                marginBottom: "0.75rem",
              }}
            >
              Technology we play with&nbsp;
              <span style={{ color: "#563D7C" }}>...</span>
            </h2>
            <div
              style={{
                width: 48,
                height: 3,
                // background: '#563D7C',
                // borderRadius: 2,
                opacity: 0.5,
              }}
            />
          </div>

          {/* Logo grid */}
          <div
            className="rounded-4 p-3 p-md-4"
            style={
              {
                // border: '1px solid rgba(86,61,124,0.08)',
                // background: '#faf8fd',
              }
            }
          >
            <div
              style={{
                overflow: "hidden",
                width: "100%",
              }}
              onMouseEnter={() => setPaused(true)}
              onMouseLeave={() => setPaused(false)}
            >
              <motion.div
                style={{
                  display: "flex",
                  width: "max-content",
                  x,
                }}
              >
                {[...techs, ...techs].map((tech, i) => (
                  <div key={i} style={{ flex: "0 0 auto", width: "120px", height:"120px" }}>
                    <TechLogo
                      src={tech.src}
                      width={tech.width}
                      height={tech.height}
                    />
                  </div>
                ))}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </Element>
  );
};

export default Projectprogress;
